import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId) => {
  const params = { include_disabled: false };
  const endpoint = URLS.venue.classes(venueId);

  return httpClient.get(endpoint, { params }).then(transformClientResponse);
};

export default makeEntityScaffold('SAGA.API.VENUE_ENABLED_CLASSES', handler, {
  defaultKey: (client, venueId) => venueId,
});
